import React from 'react';
import { styled } from '@mui/system';

// Native-scrollbar replacement for the dropped react-perfect-scrollbar
// wrapper (unmaintained since 2020, loose React peer deps that no longer
// match React 19). All three call sites (Drawer, Chat LeftSidebar, Profession
// Slides) already wrap this in an outer container with overflow:auto, so the
// inner perfect-scrollbar overlay was decorative more than functional.
// Modern browsers expose enough scrollbar styling via `scrollbar-width` and
// `scrollbar-color` plus `::-webkit-scrollbar` to get a thin, low-contrast
// scrollbar for free — net win in bundle weight and zero React-19 risk.
const ScrollbarRoot = styled('div')(() => ({
  height: '100%',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.3) transparent',
  '&::-webkit-scrollbar': { width: 8, height: 8 },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 4
  },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' }
}));

// `options` / `setScrollbarRef` were react-perfect-scrollbar-specific props.
// They're intentionally destructured and dropped here so they don't leak as
// unknown attributes onto the <div>; the rest of the props (className,
// style, onScroll, etc.) flow through normally.
const Scrollbar = React.forwardRef(function Scrollbar(
  { children, options: _options, setScrollbarRef: _setRef, ...rest },
  ref
) {
  return (
    <ScrollbarRoot ref={ref} {...rest}>
      {children}
    </ScrollbarRoot>
  );
});

export default Scrollbar;
